import React from "react";
import { gettext } from "web/script/modules/django-i18n";
import url from "web/script/utils/url";

type SignInLinkProps = {
    signInLink: string;
    next?: string;
    searchTerm?: string;
    searchGender?: string;
    type?: string;
    productId?: string;
    designerId?: string;
    emailAddress?: string;
    className?: string;
    emailCapture?: boolean;
    area: string;
};

export default function SignInLink({
    signInLink,
    next,
    searchTerm,
    searchGender,
    type,
    productId,
    designerId,
    emailAddress,
    className,
    emailCapture = false,
    area,
}: SignInLinkProps): JSX.Element {
    function getSignInLinkProps(): string {
        const parsedURL = url.parse(window.location.href);
        // work out what the 'next' parameter should be
        parsedURL.searchParams.set("loggedin", "true");
        parsedURL.searchParams.set("area", area);

        const path = next || parsedURL.path;
        const params = url.toQueryString(parsedURL.searchParams);
        const nextParam = next || `${path}${params && `?${params}`}`;
        const searchTermParam = searchTerm || parsedURL.searchParams.get("q");
        const searchGenderParam =
            searchGender ||
            parsedURL.searchParams.get("gender") ||
            parsedURL.searchParams.get("meta_gender");

        const queryParams = url
            .toQueryString({
                type: type,
                product_id: productId,
                designer_id: designerId,
                search_query: searchTermParam,
                search_gender: searchGenderParam,
                email_capture: emailCapture.toString(),
                next: nextParam,
                email: emailAddress,
            })
            .toString();

        return `href=${signInLink}?${queryParams} target="_blank"`;
    }

    return (
        <div
            className={className}
            dangerouslySetInnerHTML={{
                __html: gettext("account.register.existing_user_sign_in_link_text", {
                    sign_in_link_props: getSignInLinkProps(),
                }),
            }}
        />
    );
}
